export const UnOrderedList = ({ children }) => (
	// <ul className="mb-4 list-outside list-disc pl-6 marker:text-2xl marker:text-[#60435F]">
	<ul className="mb-4 ml-4 list-disc pl-6 text-justify text-sm marker:text-2xl lg:text-lg">
		{children}
	</ul>
)

export const OrderedList = ({ children }) => (
	<ol className="mb-4 ml-4 list-decimal pl-6 text-justify text-sm marker:font-bold lg:text-lg">
		{children}
	</ol>
)

export const ListItem = ({ children }) => (
	<li className="text-sm lg:text-lg">{children}</li>
)
